import { render, staticRenderFns } from "./l-field.vue?vue&type=template&id=4fd5a06a&"
import script from "./l-field.vue?vue&type=script&lang=js&"
export * from "./l-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports